module.exports = __webpack_public_path__ + "static/img/2023年历-9.f52905b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-9.jpg
// module id = qJQh
// module chunks = 3